// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase, */
import Price from "@kiwicom/frontend-common/records/Price"
import type { PriceType } from "@kiwicom/nitro/lib/records/Price"
import type { ConvertPrice } from "@kiwicom/frontend-common/services/currencies/selectors"

import type { Category } from "../../../../../../../../consts/additionalServices"
import type {
  BookingId,
  Currency,
  ShoppingBasketId,
} from "../../../../../../../../types/primitiveTypes"
import * as api from "../api"
import mmbTrack from "../../../../../../../../services/tracking/mmbTrack"
import {
  ErrorOccurredAction,
  PaymentModule,
  PostFormAction,
} from "../../../../../../../../services/tracking/constants/trackingEvents"

export const convertPriceRecord = (
  convertPrice: ConvertPrice,
  currency: Currency,
  price: PriceType,
): Price => {
  if (price.amount === 0) {
    return new Price({
      amount: 0,
      base: 0,
      currency,
      service: 0,
      serviceFlat: 0,
      merchant: 0,
    })
  }
  const priceComponents = ["base", "service", "serviceFlat", "merchant"].map((priceComponent) => {
    return {
      type: priceComponent,
      // @ts-expect-error: Flow to TS migration.
      ratioToTotalAmount: price[priceComponent] / price.amount,
    }
  })
  const convertedAmount = convertPrice(currency, price.amount)
  const convertedComponents = priceComponents.map((priceComponent) => {
    return {
      type: priceComponent.type,
      // `toFixed` ensures that total amount send to server is equal to sum of its price components.
      // Limiting precision to 2 fraction digit is because Price.toServer() is using the same
      // precision for price components conversion to string.
      value: parseFloat((priceComponent.ratioToTotalAmount * convertedAmount).toFixed(2)),
    }
  })
  const totalAmount = convertedComponents.reduce((acc, component) => {
    return acc + component.value
  }, 0.0)
  return new Price({
    amount: totalAmount,
    base: convertedComponents.find((component) => component.type === "base")?.value,
    currency,
    service: convertedComponents.find((component) => component.type === "service")?.value,
    serviceFlat: convertedComponents.find((component) => component.type === "serviceFlat")?.value,
    merchant: convertedComponents.find((component) => component.type === "merchant")?.value,
  })
}

type ProcessPaymentArgs = {
  bid: BookingId
  basket_id: ShoppingBasketId
  category: Category
  currency: Currency
}
/**
 * Starts processing of free payment, redirecting user to correct thank you page after it
 *
 * @returns {Promise<void>}
 */
export const processFreePayment = async ({
  bid,
  basket_id,
  currency,
  category,
}: ProcessPaymentArgs) => {
  try {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const freePaymentPayload: Record<string, any> = {}
    const { status, fraud_status: fraudStatus, errors } = await api.startProcessingPayment(
      bid,
      basket_id,
      freePaymentPayload,
    )

    mmbTrack(
      {
        module: PaymentModule,
        action: PostFormAction,
        detail: "process payment free",
      },
      {
        bid,
        basketId: basket_id,
        abid: null,
        response: { status },
        fraudStatus,
        errors,
        type: "process payment free",
      },
    )
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    mmbTrack(
      {
        module: PaymentModule,
        action: ErrorOccurredAction,
      },
      {
        basketId: basket_id,
        currency,
        category,
        detail: "Failed to process free payment",
      },
    )

    // throwing error for the parent function (handlePaymentRedirect), so we can open 'Payment failed' modal there
    throw error
  }
}
